// extracted by mini-css-extract-plugin
module.exports = {"root":"AppBlock_root__3oxX3"};